import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { getUserPreferences } from '../utils/api-helper';
import { setDefaultMapLayer } from '../redux/slices/mapPreferences';

/**
 * Loads the signed-in user's saved preferences (currently the default map
 * layer) whenever the user changes (login, impersonation) and seeds Redux with
 * them. Falls back silently to the default layer if the request fails.
 */
const useUserPreferences = (userId) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (!userId) return undefined;

    let cancelled = false;

    (async () => {
      try {
        const resp = await getUserPreferences();
        if (!cancelled && resp?.data?.defaultMapLayer) {
          dispatch(setDefaultMapLayer(resp.data.defaultMapLayer));
        }
      } catch {
        // Keep the default layer; no user-facing error for a silent preference.
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [userId, dispatch]);
};

export default useUserPreferences;
